export default "__VITE_ASSET__DsvAS3H8__"